/** @format */

import { useEffect, useState } from 'react';
import { Box, Paper, Popper, Typography, Container } from '@mui/material';
import { COMPONENT_TITLE_SX } from '../homeStyles';
import Guage from '../Cards/Guage';
import { getRevBudget } from '../../../../Services/service.home';
import { buildPayload } from '../../../Library/appfilter.lib';
import { useAppContext } from '../../../../store/store.app';
import { TouchApp } from '@mui/icons-material';

const ITEMS = [
  {
    id: 'room_revenue',
    title: 'Room Rev',
  },
  {
    id: 'fnb_revenue',
    title: 'F&B Rev',
  },
  {
    id: 'spa_revenue',
    title: 'Spa Rev',
  },
  {
    id: 'mod_revenue',
    title: 'MOD Rev',
  },
  {
    id: 'total_revenue',
    title: 'Total Rev',
  },
];

function RevBudget() {
  return (
    <Container
      maxWidth="lg"
      className="flash-report-rev-budget"
      sx={{
        px: {
          xs: 0,
          sm: 2,
          md: 3,
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          mt: 2,
          width: '100%',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: 0,
          }}
        >
          <Tooltip />
        </Box>

        <Typography
          textAlign="center"
          variant="h6"
          color="text.disabled"
          sx={{
            ...COMPONENT_TITLE_SX,
            flexGrow: 1,
            minWidth: 0,
            overflowWrap: 'anywhere',
          }}
        >
          Rev (000) vs Budget
        </Typography>

        <Typography
          fontSize={12}
          color="text.secondary"
          sx={{
            position: 'absolute',
            right: 0,
            display: {
              xs: 'none',
              sm: 'block',
            },
          }}
        >
          Revenue in &#39;000
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: 1,
          mt: 1,
        }}
      >
        <Paper
          square
          variant="outlined"
          sx={{
            width: '100%',
            p: 1,
            backgroundColor: '#ffffff',
            boxSizing: 'border-box',
            borderRadius: 2,
          }}
        >
          <Typography
            textAlign="center"
            variant="h6"
            sx={{
              mb: 0.5,
              fontSize: {
                xs: '0.95rem',
                sm: '1rem',
              },
              fontWeight: 600,
            }}
          >
            MTD
          </Typography>

          <Box
            sx={{
              display: 'grid',

              gridTemplateColumns: {
                xs: 'repeat(2, minmax(0, 1fr))',
                sm: 'repeat(3, minmax(0, 1fr))',
                md: 'repeat(5, minmax(0, 1fr))',
              },

              columnGap: 1,
              rowGap: 1,
              width: '100%',
              alignItems: 'stretch',
            }}
          >
            {ITEMS.map((item, index) => {
              const isLastItem = index === ITEMS.length - 1;

              return (
                <Box
                  key={item.id}
                  sx={{
                    width: '100%',
                    minWidth: 0,

                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'stretch',

                    ...(isLastItem && {
                      gridColumn: {
                        xs: '1 / -1',
                        sm: 'auto',
                        md: 'auto',
                      },
                    }),
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        xs: isLastItem ? '50%' : '100%',
                        sm: '100%',
                        md: '100%',
                      },

                      minWidth: 0,
                    }}
                  >
                    <Chart kpiId={item.id} KpiName={item.title} slot="mtd" />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Paper>

        <Paper
          square
          variant="outlined"
          sx={{
            width: '100%',
            p: 1,
            backgroundColor: '#ffffff',
            boxSizing: 'border-box',
            borderRadius: 2,
          }}
        >
          <Typography
            textAlign="center"
            variant="h6"
            sx={{
              mb: 0.5,
              fontSize: {
                xs: '0.95rem',
                sm: '1rem',
              },
              fontWeight: 600,
            }}
          >
            YTD
          </Typography>

          <Box
            sx={{
              display: 'grid',

              gridTemplateColumns: {
                xs: 'repeat(2, minmax(0, 1fr))',
                sm: 'repeat(3, minmax(0, 1fr))',
                md: 'repeat(5, minmax(0, 1fr))',
              },

              columnGap: 1,
              rowGap: 1,
              width: '100%',
              alignItems: 'stretch',
            }}
          >
            {ITEMS.map((item, index) => {
              const isLastItem = index === ITEMS.length - 1;

              return (
                <Box
                  key={item.id}
                  sx={{
                    width: '100%',
                    minWidth: 0,

                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'stretch',

                    ...(isLastItem && {
                      gridColumn: {
                        xs: '1 / -1',
                        sm: 'auto',
                        md: 'auto',
                      },
                    }),
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        xs: isLastItem ? '50%' : '100%',
                        sm: '100%',
                        md: '100%',
                      },

                      minWidth: 0,
                    }}
                  >
                    <Chart kpiId={item.id} KpiName={item.title} slot="ytd" />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

function Chart({ kpiId, slot, KpiName }) {
  const [data, setData] = useState(null);

  const {
    appStore: { appFilters },
  } = useAppContext();

  const { PARAMETER, CALC_DATERANGE } = appFilters;

  const basePayload = {};

  const payload = {
    ...buildPayload(appFilters),
    ...basePayload,
  };

  async function fetchData() {
    try {
      const response = await getRevBudget(kpiId, slot, payload);

      setData(response.data);
    } catch (error) {
      console.error('Error fetching revenue budget data:', kpiId, slot, error);
    }
  }

  useEffect(() => {
    if (!CALC_DATERANGE || !PARAMETER) {
      return;
    }

    fetchData();
  }, [kpiId, slot, CALC_DATERANGE, PARAMETER]);

  return <Guage key={`${kpiId}-${slot}`} name={KpiName} data={data} />;
}

function Tooltip() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        sx={{
          color: 'text.disabled',
          cursor: 'pointer',
          zIndex: 1,
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <TouchApp
          fontSize="small"
          sx={{
            color: '#757575',
          }}
        />
      </Box>

      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement="right-start"
      >
        <Box
          sx={{
            minWidth: 'fit-content',
            maxWidth: {
              xs: '90vw',
              sm: 'none',
            },
            backgroundColor: '#e8e4e4',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 2,
            p: 1,
            zIndex: 1300,
          }}
        >
          <Box sx={{ p: 1 }}>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 'bold',
                mb: 1,
              }}
            >
              Gauge Information
            </Typography>

            <Box sx={{ mb: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.8rem',
                }}
              >
                • Hover over gauge needle for detailed data
              </Typography>
            </Box>

            <Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 'medium',
                  mb: 0.5,
                }}
              >
                Color Codes:
              </Typography>

              <Box sx={{ pl: 2 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.75rem',
                  }}
                >
                  🔴 Red: Below 95%
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.75rem',
                  }}
                >
                  🟡 Amber: 95% - 100%
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontSize: '0.75rem',
                  }}
                >
                  🟢 Green: Above 100%
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Popper>
    </>
  );
}

export default RevBudget;
